import { Injectable } from '@angular/core';
import { IPayment } from '../interfaces/ipayment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import _ from 'lodash';
import { DatastoreService } from './datastore.service';

@Injectable({
  providedIn: 'root'
})
export class CapitaService extends IPayment {

  override url = (window.location.href.includes("localhost") || window.location.href.includes("staging")) ? 'https://staging.bookinglab.co.uk' : 'https://api.bookinglab.co.uk';
  override path = "/" //(window.location.hostname == 'localhost' || window.location.hostname.includes('cloudfront.net')) ? '/' : '/gds-angular-core';

  constructor(
    private http: HttpClient,
    private datastoreService: DatastoreService
  ) {
    super();
  }
  invoke(
    company: any,
    booking: any,
    purchase: any,
    client: any,
    description: any, fundCode: any, reference: any, price: any, vatOptOut: any) {
    if (!fundCode) {
      fundCode = 'MISC';
    }

    let port = '';
    const ports: any = ['80', '443'];
    if (ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    const configObj: any = this.datastoreService.config
    const vat = Math.round((price / 120) * 20)
    const body = {
      host: `${configObj.host}`,
      company_id: `${company.id}`,
      booking_id: `${booking.id}`,
      purchase_id: `${purchase.id}`,
      client_id: `${client.id}`,
      fund_code: `${fundCode}`,
      description: `${description}`,
      reference: `${reference}`,
      amount: price,
      send_user_details: true, // this adds the billingDetails element to the Capita XML with the card holder name and email pre-populated in the portal
      combine_reference: false,
      add_account_details: true, // This adds the accountName field to the lgItemDetails section of the Capita XML
      vat_opt_out: false,
      vatAmountInMinorUnits: vat,
      vatRate: 20.00,
      vat_code: "S",
      return_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}/payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`,
      back_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}/payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`
    }

    return this.http.post(`${this.url}/payment/capita/invoke`, body).toPromise();
  }
  query(paymentRef: any) {
    console.log(this.datastoreService.config)
    const configObj: any = this.datastoreService.config

    const body = {
      host: `${configObj.host}`,
      scp_id: paymentRef
    };
    return this.http.post(`${this.url}/payment/capita/query`, body).toPromise();
  }
  find(purchaseId: any, companyId: any) {
    const configObj: any = this.datastoreService.config

    const body = {
      host: `${configObj.host}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`
    }

    return this.http.post(`${this.url}/payment/capita/find`, body).toPromise();
  }
  confirm(purchaseId: any, companyId: any, amount: number) {
    const configObj: any = this.datastoreService.config

    const body = {
      host: `${configObj.host}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`,
      amount: `${amount}`,
    }

    return this.http.post(`${this.url}/payment/capita/confirm`, body).toPromise();
  }
  vatExemption(companyId: any, serviceItems: any) {
    const configObj: any = this.datastoreService.config

    const body = {
      host: `${configObj.host}`,
      company_id: `${companyId}`,
      service_items: serviceItems

    };
    return this.http.post(`${this.url}/payment/capita/vat-exemption`, body).toPromise();
  }
}
